
import React from "react";
import { TodoBottomSheetStackScreenProps } from "./TodoBottomSheetStack";
import { TodoEditLinkProductComponent } from "../../TodoEdit/TodoEditLinkProduct";

export function TodoBottomSheetLinkProduct(
  props: TodoBottomSheetStackScreenProps<"linkProduct">
) {
  return (
    <TodoEditLinkProductComponent
      goBack={props.navigation.goBack}
      id={props.route.params.todoId}
      inBottomSheet={true}
    />
  );
}
